import { Directive, Output, HostListener, EventEmitter, ElementRef, Renderer2, Input } from '@angular/core';

@Directive({
    selector: '[dbDropdownClick]'
})
export class DropdownClickDirective {
    @Input() disabled: boolean;
    @Input() closeOnSelect: boolean;
    @Input() closeOnElement?: HTMLElement;
    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() select: EventEmitter<any> = new EventEmitter();

    constructor(private _renderer: Renderer2, private _elementRef: ElementRef) {
        this.closeOnSelect = true;
    }

    @HostListener('body:click', ['$event', '$event.target']) handleClick($event: MouseEvent, targetElement: HTMLElement) {
        if (!targetElement || this.disabled) {
          return;
        }
        if ($event.button === 0) {
          if (!this._elementRef.nativeElement.contains(targetElement)) {
              this.close();
          } else if (this.isOpen() && targetElement === this.closeOnElement) {
              this.close();
          } else {
              this.toggle();
          }
        }
    }
    @HostListener('keyup', ['$event']) handleEscPress($event: KeyboardEvent) {
      if ($event.code === 'Escape' || $event.code === 'Enter') {
          if (!this.isOpen()) {
              this.toggle();
          } else {
              this.close();
          }
      }
    }

    private isOpen(): boolean {
        return this._elementRef.nativeElement.classList.contains(this.recalculatePosition());
    }

    private close(): void {
        if (this.isOpen()) {
            this._renderer.removeClass(this._elementRef.nativeElement, 'active');
            this._renderer.removeClass(this._elementRef.nativeElement, 'active-reverse');
        }
    }

    private open(): void {
        if (!this.isOpen()) {
            this._renderer.addClass(this._elementRef.nativeElement, this.recalculatePosition());
        }
    }

    private toggle() {
        if (this.disabled) {
            return;
        }
        if (this.isOpen()) {
            if (this.closeOnSelect) {
                this.close();
            }
        } else {
            this.open();
        }
    }
    private recalculatePosition() {
        // get the scollTop (distance scrolled from top)
        const scrollTop = document.documentElement.scrollTop;
        // get the top offset of the dropdown (distance from top of the page)
        const topOffset = this._elementRef.nativeElement.getBoundingClientRect().top;
        // calculate the dropdown offset relative to window position
        const relativeOffset = topOffset - scrollTop;
        // get the window height
        const windowHeight = document.documentElement.clientHeight;

        // if the relative offset is greater than half the window height,
        // reverse the dropdown.

        if (relativeOffset > (windowHeight / 1.5)) {
            return 'active-reverse';
        } else {
            return 'active';
        }
    }
}
